import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import LoadScript from 'vue-plugin-load-script'
import makeTaskStore from './task-store.js'
import store from '../../store'

Vue.use(LoadScript)
Vue.use(Vuex)

let taskStore = makeTaskStore()

export default new Vuex.Store({
  state: {
    ...store.state,
    ...taskStore.state,

    kekulePromise: new Promise((resolve, reject) => {
      Vue.loadScript('/static/kekule/kekule.min.js').then((loaded) => {
        console.log('Load Kekule success!')
        resolve()
      }).catch(() => {
        console.log('Load Kekule failed!')
      })
    }),

    smilesDrawerPromise: new Promise((resolve, reject) => {
      Vue.loadScript('/static/smiles-drawer/smiles-drawer.min.js').then((loaded) => {
        console.log('Load SmilesDrawer success!')
        resolve()
      }).catch(() => {
        console.log('Load SmilesDrawer failed!')
      })
    })
  },

  mutations: {
    ...store.mutations,
    ...taskStore.mutations,
  },

  actions: {
    ...store.actions,
    ...taskStore.actions,
  },

  getters: {
    ...store.getters,
    ...taskStore.getters
  }
})
